import { createFileRoute } from "@tanstack/react-router";
import StoryExperience from "@/components/StoryExperience";

const URL = "https://www.travelbackland.com/outdoor-glamping-events";
const TITLE = "Outdoor Glamping Events & Wellness Retreats in Arizona | Backland";
const DESC =
  "Host outdoor events and wellness retreats at Backland: open-air venues, luxury tented lodging, and 160 private acres of Arizona high country for groups that want to gather under the sky.";
const OG_IMAGE =
  "/__l5e/assets-v1/5a8c904d-9fd4-4bbf-85ed-2a0f99e4fa33/tent-night-sky.png";

export const Route = createFileRoute("/outdoor-glamping-events")({
  head: () => ({
    meta: [
      { title: TITLE },
      { name: "description", content: DESC },
      { property: "og:title", content: TITLE },
      { property: "og:description", content: DESC },
      { property: "og:url", content: URL },
      { property: "og:type", content: "website" },
      { property: "og:image", content: OG_IMAGE },
      { name: "twitter:card", content: "summary_large_image" },
    ],
    links: [{ rel: "canonical", href: URL }],
    scripts: [
      {
        type: "application/ld+json",
        children: JSON.stringify({
          "@context": "https://schema.org",
          "@type": "Service",
          name: "Outdoor Events & Wellness Retreats at Backland",
          serviceType: "Outdoor events and wellness retreats",
          url: URL,
          description: DESC,
          areaServed: { "@type": "State", name: "Arizona" },
          provider: {
            "@type": "LodgingBusiness",
            name: "Backland",
            address: { "@type": "PostalAddress", addressRegion: "AZ", addressCountry: "US" },
          },
        }),
      },
    ],
  }),
  component: OutdoorEventsRoute,
});

function OutdoorEventsRoute() {
  return <StoryExperience initialCategorySlug="groups" />;
}
